import { useQuery } from "@apollo/client";

import { CLIPS_RELOADED } from "MVVM/GraphQL/wrapped";

const WrappedWidgetViewModel = () => {
  const { data, error, loading } = useQuery(CLIPS_RELOADED, {
    fetchPolicy: "cache-and-network",
    variables: {
      limit: 6,
    },
  });

  return {
    data,
    error,
    loading,
  };
};

export { WrappedWidgetViewModel };
